<section class="footer" [ngClass]="dynamicClassName">
  <div class="container-xl footer-top pb-5 mb-5">
    <div class="row ps-lg-5 ps-2 pe-lg-5 pe-2">
      <div class="col-lg-3 col-md-6 pe-0 pe-sm-5">
        <div class="logofooter pe-3 mb-3 mb-md-5">
          <a href="#"
            ><img class="img-fluid" src="assets/images/w2c/lightlogo.png"
          /></a>
        </div>
      </div>
      <div class="col-lg-5 col-md-6 mb-4 mbextamargin">
        <h3 class="text-light fz-22 mb-4">Contact Us</h3>
        <h2 class="display-6 fw-bold text-primary text-left mb-3">
          +61 2 9225 7599
        </h2>
        <p class="text-light mb-0">Monday to Friday, 8am to 9pm AEST</p>
        <p class="text-light">Saturday and Sunday, 9am to 6pm AEST</p>
        <p class="text-light">
          Email: <br /><a
            class="text-decoration-none"
            href="mailto:travelservice@world2cover.com.au"
            ><span class="text-primary"
              >travelservice&#64;world2cover.com.au</span
            ></a
          >
        </p>
        <p class="text-light">
          Address: <br /><span class="text-primary"
            >World2Cover, GPO Box 4616, SYDNEY NSW 2001</span
          >
        </p>
      </div>
      <div class="col-lg-2 col-md-6 col-6">
        <h3 class="text-light mb-4">About</h3>
        <ul class="list-unstyled footerlink">
          <li>
            <a
              routerLink="/about-us"
              [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
              target="_blank"
              class="text-decoration-none text-primary mb-2 fw-normal"
              >About Us</a
            >
          </li>
          <li>
            <a
              [routerLink]="['/w2cawards']"
              [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
              [queryParamsHandling]="'merge'"
              target="_blank"
              class="text-decoration-none text-primary mb-2 fw-normal"
              >World2Cover Awards</a
            >
          </li>
        </ul>
      </div>
      <div class="col-lg-2 col-md-6 col-6">
        <h3 class="text-light mb-4">Guides</h3>
        <ul class="list-unstyled footerlink">
          <li>
            <a
              routerLink="/refunds"
              [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
              target="_blank"
              class="text-decoration-none text-primary mb-2 fw-normal"
              >Refunds</a
            >
          </li>
          <li>
            <a
              [routerLink]="pdsService.getWhiteLabelPdsRouterLink(partnerCode)"
              [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
              target="_blank"
              class="text-decoration-none text-primary mb-2 fw-normal"
              (click)="triggerSegmentEvent('travelInsurancePds')"
              >Policy Documentation</a
            >
          </li>
          <li>
            <a
              routerLink="/terms-and-conditions"
              [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
              target="_blank"
              class="text-decoration-none text-primary mb-2 fw-normal"
              >Terms & Conditions</a
            >
          </li>
          <li>
            <a
              routerLink="/privacy-policy"
              [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
              target="_blank"
              class="text-decoration-none text-primary mb-2 fw-normal"
              >Privacy Policy</a
            >
          </li>
          <li>
            <a
              routerLink="/contact-us"
              [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
              target="_blank"
              class="text-decoration-none text-primary mb-2 fw-normal"
              >Contact Us</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="container-xl footer-bottom">
    <div class="row ps-md-5 ps-2 pe-md-5 pe-2" [ngSwitch]="partnerCode">
      <p *ngSwitchCase="'Klook'" class="text-light text-small">
        This World2Cover travel insurance product is distributed by Klook Travel
        Technology Limited, Hong Kong company no. 63303940 (Klook), as an
        authorised representative (no. 1314489) of the insurer and issuer, Tokio
        Marine & Nichido Fire Insurance Co., Ltd., AFSL 246548 (Tokio Marine &
        Nichido). All other services for this policy are provided by Tokio
        Marine & Nichido’s authorised representative (no. 1313066) Tokio Marine
        Management (Australasia) Pty Ltd (TMMA). Any advice is general only.
        Eligibility criteria apply. First read the
        <a
          [routerLink]="pdsService.getWhiteLabelPdsRouterLink(partnerCode)"
          [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
          target="_blank"
          class=""
          (click)="triggerSegmentEvent('pds_footer_3')"
          >Combined Product Disclosure Statement and Financial Services Guide</a
        >
        and the
        <a
          [routerLink]="pdsService.getWhiteLabelPdsRouterLink(partnerCode)"
          [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
          class=""
          target="_blank"
          (click)="triggerSegmentEvent('tmd_footer_2')"
          >Target Market Determination.</a
        >
      </p>
      <p class="desclaimer text-light" *ngIf="partnerCode === 'Klook'">
        <small>*See PDS for eligibility criteria</small>
      </p>
      <p *ngSwitchCase="'vacatio'" class="text-light text-small">
        VCT Travel Pty Ltd (ABN 70 632 976 286, AR No. 1317992), trading as
        Vacatio, is an authorised representative of the product issuer Tokio
        Marine & Nichido Fire Insurance Co., Ltd. (ABN 80 000 438 291 AFSL 246
        548) (Tokio Marine) who promotes and distributes World2Cover Travel
        Insurance. World2Cover is a business name of Tokio Marine. Tokio Marine
        Management (Australasia) Pty Ltd (ABN 69 001 488 455, AR No. 1313066) is
        an authorised representative of Tokio Marine, and administers
        World2Cover Travel Insurance as the managing agent on behalf of Tokio
        Marine. Terms, conditions (including eligibility criteria), exclusions,
        limits and sub-limits apply. Any advice is general advice only, and does
        not take into account your specific objectives, financial situation or
        needs. Before you purchase, please consider the
        <a
          [routerLink]="pdsService.getWhiteLabelPdsRouterLink(partnerCode)"
          [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
          target="_blank"
          class=""
          (click)="triggerSegmentEvent('pds_footer_3')"
          >Combined Product Disclosure Statement (PDS) / Financial Services
          Guide (FSG)</a
        >
        and
        <a
          [routerLink]="pdsService.getWhiteLabelPdsRouterLink(partnerCode)"
          [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
          class=""
          target="_blank"
          (click)="triggerSegmentEvent('tmd_footer_2')"
          >Target Market Determinations (TMDs)</a
        >
        available on the Vacatio/World2Cover website, or on request from
        Vacatio.
      </p>
      <p *ngSwitchDefault class="text-light text-small">
        Tokio Marine Management (Australasia) Pty Ltd (ABN 69 001 488 455) is
        the provider of World2Cover Insurance, as an authorised representative
        (AR 1313066) of the product’s issuer, Tokio Marine & Nichido Fire
        Insurance Co., Ltd. (ABN 80 000 438 291 AFSL 246 548). Any advice set
        out above is general in nature only, and does not take into account your
        objectives, financial situation or needs. Before purchasing any travel
        products, we recommend reviewing the
        <a
          [routerLink]="pdsService.getWhiteLabelPdsRouterLink(partnerCode)"
          [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
          target="_blank"
          class=""
          (click)="triggerSegmentEvent('pds_footer_1')"
          >World2Cover Product Disclosure Statement (PDS)</a
        >
        and the
        <a
          [routerLink]="pdsService.getWhiteLabelPdsRouterLink(partnerCode)"
          [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
          class=""
          target="_blank"
          (click)="triggerSegmentEvent('tmd_footer_1')"
          >Target Market Determinations (TMDs)</a
        >
        that apply to these products. Please read the
        <a
          [routerLink]="pdsService.getWhiteLabelPdsRouterLink(partnerCode)"
          [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
          target="_blank"
          class=""
          (click)="triggerSegmentEvent('pds_footer_2')"
          >World2Cover Combined Financial Services Guide and Product Disclosure
          Statement</a
        >
        for full details of terms and conditions, limits (including sub-limits)
        and exclusions apply to each of our policies and the different benefits.
        TMDs outline the intended class of customers that comprise the target
        market for these travel products, including key attributes of the
        insurance cover and eligibility criteria. A TMD does not replace the
        terms and conditions, nor the disclosures make, in a PDS so you should
        read the applicable PDS carefully and contact us if you have any
        queries. A copy of our PDS, Supplementary
        <a
          [routerLink]="pdsService.getWhiteLabelPdsRouterLink(partnerCode)"
          [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
          target="_blank"
          class=""
          (click)="triggerSegmentEvent('pds_footer_3')"
          >PDS</a
        >
        and
        <a
          [routerLink]="pdsService.getWhiteLabelPdsRouterLink(partnerCode)"
          [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
          class=""
          target="_blank"
          (click)="triggerSegmentEvent('tmd_footer_2')"
          >TMD's</a
        >
        for each travel product can be found in
        <a
          [routerLink]="pdsService.getWhiteLabelPdsRouterLink(partnerCode)"
          [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
          class=""
          target="_blank"
          (click)="triggerSegmentEvent('tmd_footer_3')"
          >here</a
        >.
      </p>
    </div>
  </div>
</section>
